import React from 'react';
import { Navigate } from 'react-router';
import Base from '../Base';
import { Header } from '../Header';
//https://s-yadav.github.io/react-number-format/docs/numeric_format/
import NumberFormat from 'react-number-format';

export default class CustomerClubLevel extends Base {
	constructor(props) {
		super(props);
		this.state = {
			caller: props.Caller,
			controllerName: 'customerclublevel',
			refreshCallerAfterSave: this.isNull(props.RefreshCallerAfterSave) ? true : props.RefreshCallerAfterSave,
			id: this.isNull(props.Id) ? this.defaultGuid() : props.Id,
			data: null,
			loading: true,
		};
		this.keyDownFunction = this.keyDownFunction.bind(this);
	}
	componentWillUnmount() {
		this.removeKeyDown();
	}
	componentDidMount() {
		this.addKeyDown();
		this.refreshData();
	}
	save(e) {
		e.preventDefault();

		if (this.isBlank(this.state.data.record.minPoint)) this.state.data.record.minPoint = 0;
		if (this.isBlank(this.state.data.record.maxPoint)) this.state.data.record.maxPoint = 0;
		if (this.isBlank(this.state.data.record.discountPercent)) this.state.data.record.discountPercent = 0;

		this.httpPost("api/v1/customerclublevel/save", {
			id: this.state.id,
			organizationId: this.state.data.global.company.id,
			description: this.state.data.record.description,
			name: this.state.data.record.name,
			minPoint: this.state.data.record.minPoint,
			maxPoint: this.state.data.record.maxPoint,
			discountPercent: this.state.data.record.discountPercent,
		})
			.then(data => {
				if (data.status === -1) window.location.href = "/login";
				if (data.status === 1) {
					this.showSuccessMessage("اطلاعات با موفقیت ذخیره شد");

					if (this.state.refreshCallerAfterSave)
						this.state.caller.refreshData();

					this.closeMe();
				}
				else {
					this.showErorrMessage(data.message);
					this.setState({
						loading: false
					});
				}
			});
	}
	refreshData() {
		this.httpPost("api/v1/customerclublevel/get", {
			id: this.state.id,
		})
			.then(data => {
				if (data.status === -1) window.location.href = "/login";
				if (data.status === 1) {
					window.organizationId = data.global.company.id;
					this.state.data = data;
					this.state.loading = false;
				}
				else {
					this.showErorrMessage(data.message);
					this.setState({
						loading: false
					});
				}
			});
	}
	renderForm() {
		return <div className="modal fade listModal in show" tabIndex="-1" role="dialog">
			<div className="modal-backdrop fade in" style={{ "height": "100%" }} onClick={e => this.closeMe()}></div>
			<div className="modal-dialog ui-draggable" style={{ "width": "96%", "left": "7.125px", "top": "-2px" }}>
				<div className="modal-content">
					<div className="modal-body">
						<div className="modal-header modal-header-info" style={{ "padding": "0" }}>
							<button type="button" className="close" onClick={e => this.closeMe()} aria-label="Close"><span aria-hidden="true">×</span></button>
							<h4 className="modal-title">سطح باشگاه مشتریان</h4>
						</div>
						<div className="modal-body" style={{ "display": "flex", "flex-direction": "column", "gap": "10px" }}>
							<div className="row">
								<div className="col-sm-12">
									<div className="form-group">
										<label for="invoiceNumber" className="title1">عنوان</label>
										<input onChange={e => this.state.data.record.name = e.target.value} defaultValue={this.state.data.record.name} type="text" className="form-control input-smnumber" />
									</div>
								</div>
								<div className="col-sm-2">
									<div className="form-group">
										<label for="invoiceNumber" className="title1">حداقل امتیاز</label>
										<input onChange={e => this.state.data.record.minPoint = parseInt(e.target.value)} defaultValue={this.state.data.record.minPoint} type="text" className="form-control input-smnumber ltr" />
									</div>
								</div>
								<div className="col-sm-2">
									<div className="form-group">
										<label for="invoiceNumber" className="title1">حداکثر امتیاز</label>
										<input onChange={e => this.state.data.record.maxPoint = parseInt(e.target.value)} defaultValue={this.state.data.record.maxPoint} type="text" className="form-control input-smnumber ltr" />
									</div>
								</div>
								<div className="col-sm-2">
									<div className="form-group">
										<label for="invoiceNumber" className="title1">درصد تخفیف</label>
										<input onChange={e => this.state.data.record.discountPercent = parseInt(e.target.value)} defaultValue={this.state.data.record.discountPercent} type="text" className="form-control input-smnumber ltr" />
									</div>
								</div>
								<div className="col-sm-12">
									<div className="form-group">
										<label for="invoiceNumber" className="title1">توضیحات</label>
										<input onChange={e => this.state.data.record.description = e.target.value} defaultValue={this.state.data.record.description} type="text" className="form-control input-smnumber" />
									</div>
								</div>
							</div>
						</div>
						<div className="modal-footer">
							<button type="button" className="hand btn btn-primary" onClick={e => this.save(e)} >ذخیره</button>
							<a className="btn btn-warning" onClick={e => this.closeMe()}>انصراف</a>
						</div>
					</div>
				</div>
			</div>
		</div>
	}
	render() {
		if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />
		let contents = this.state.loading ? this.renderLoading() :
			[
				this.state.lockScreen === 1 && this.lockScreen(),
				this.getGlobalContainer(),
				<Header data={this.state.data} />,
				this.renderForm(),
				this.renderPopupComponent()
			];

		return contents;
	}
}